var _rect, _rect2, _rect3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.5,
    width: 16,
    height: 1.3,
    transform: "rotate(-180 16 16.5)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.65,
    y: 7.65,
    width: 12.7,
    height: 4.7,
    stroke: "black",
    strokeWidth: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.15,
    y: 0.65,
    width: 7.7,
    height: 15.2,
    stroke: "black",
    strokeWidth: 1.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.871d3ddffbac9088c93a5c377ab1f1a1.svg";
export { ForwardRef as ReactComponent };